import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useLocation, useNavigate } from 'react-router';

import { apiErrorMessage } from '../../shared/api/errors';
import { login } from './api';
import { AuthShell } from './AuthShell';
import { CredentialsForm } from './CredentialsForm';

/** Куда вернуться после входа: только внутренний путь (не //host, не URL). */
function returnPath(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//') && from !== '/login') {
    return from;
  }
  return '/patients';
}

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['me'] });
      navigate(returnPath(location.state), { replace: true });
    },
  });

  return (
    <AuthShell subtitle="Вход в систему">
      <CredentialsForm
        submitLabel="Войти"
        pending={mutation.isPending}
        errorMessage={
          mutation.isError ? apiErrorMessage(mutation.error, 'Не удалось войти') : undefined
        }
        onSubmit={(values) => mutation.mutate(values)}
      />
      <p className="mt-4 text-center text-sm">
        <Link to="/forgot-password" className="font-medium text-accent hover:text-accent-600">
          Забыли пароль?
        </Link>
      </p>
    </AuthShell>
  );
}
